/**
 * NWScriptTypes enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file NWScriptTypes.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export const NWScriptTypes = {
  'I': 3,
  'F': 4,
  'S': 5,
  'O': 6,
  
  'Effect': 16,
  'Event': 17,
  'Location': 18,
  'Talent': 19,

  'II': 32,
  'FF': 33,
  'OO': 34,
  'SS': 35,
  'TT': 36,
  'IF': 37,
  'FI': 38,

  'EFEF': 48, //Effect Effect
  'EVEV': 49, //Event Event
  'LOCLOC': 50, //Location Location
  'TALTAL': 51, //TALENT TALENT

  'VV': 58,
  'VF': 59,
  'FV': 60,
}